import { ISelectData } from 'components/atoms/SelectComponent';

import { ETypVH } from 'enums/akcionarKorpAkce/typVH';

export const typVHSelectData: ISelectData[] = [
    {
        labelcz: 'SRD_PRUVODCE_VH_C_TYPVH_XMET',
        value: ETypVH.XMET
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_C_TYPVH_GMET',
        value: ETypVH.GMET
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_C_TYPVH_MIXD',
        value: ETypVH.MIXD
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_C_TYPVH_SPCL',
        value: ETypVH.SPCL
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_C_TYPVH_BMET',
        value: ETypVH.BMET
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_C_TYPVH_CMET',
        value: ETypVH.CMET
    }
];
